import db from "../../firebase";
import { useSelector } from "react-redux";
import { collection, getDocs, query, where } from "firebase/firestore";
import { ImageListItem, IconButton, ImageListItemBar } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const SingleCard = ({
  item,
  currentScreenWidth,
  setActiveAdminCelebModal,
  setEditActiveCelebImageData,
}) => {
  const adminActiveCelebList = useSelector(
    (state) => state.adminActiveCelebList
  );

  const getActiveImageDetail = (item) => {
    const getData = async () => {
      return await getDocs(
        query(
          collection(db, `biddify/${adminActiveCelebList}/gallery`),
          where("id", "==", item.id)
        )
      );
    };

    getData().then((docs) => {
      docs.forEach((doc) => {
        setEditActiveCelebImageData({
          timeLeft: doc.data().timeLeft.toDate(),
          startTime: doc.data().startTime ? doc.data().startTime.toDate() : 0,
          highestBid: doc.data().highestBid,

          about: doc.data().details ? doc.data().details.about : "",

          about_description: doc.data().details
            ? doc.data().details.about_description
            : "",

          blockchain: doc.data().details ? doc.data().details.blockchain : "",

          contract_address: doc.data().details
            ? doc.data().details.contract_address
            : "",

          created_by: doc.data().details ? doc.data().details.created_by : "",

          created_on: doc.data().details
            ? doc.data().details.created_on.toDate()
            : "",

          metadata: doc.data().details ? doc.data().details.metadata : "",

          title: doc.data().details ? doc.data().details.title : "",

          token_id: doc.data().details ? doc.data().details.token_id : "",

          token_standard: doc.data().details
            ? doc.data().details.token_standard
            : "",

          views: doc.data().details ? doc.data().details.views : "",

          about_links_instagram: doc.data().details
            ? doc.data().details.about_links.instagram
            : "",

          about_links_trans: doc.data().details
            ? doc.data().details.about_links.trans
            : "",

          about_links_web: doc.data().details
            ? doc.data().details.about_links.web
            : "",

          properties1: doc.data().details
            ? doc.data().details.properties[0]
            : "",

          properties2: doc.data().details
            ? doc.data().details.properties[1]
            : "",

          properties3: doc.data().details
            ? doc.data().details.properties[2]
            : "",
        });
      });

      setActiveAdminCelebModal(item.id);
    });
  };

  return (
    <ImageListItem
      sx={{
        width: currentScreenWidth > 768 ? "24%" : "49%",
        margin: "0 0.5% 10px",
      }}
    >
      <img src={item.image} alt="" loading="lazy" />
      <ImageListItemBar
        title="Edit"
        actionIcon={
          <IconButton
            sx={{ color: "rgba(255, 255, 255, 0.54)" }}
            onClick={() => getActiveImageDetail(item)}
          >
            <EditIcon />
          </IconButton>
        }
      />
    </ImageListItem>
  );
};

export default SingleCard;
